import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import InquiryTypesSection from "./components/InquiryTypesSection";
import ContactForm from "./components/ContactForm";
import NotesSection from "./components/NotesSection";
import { useContactData } from "../../lib/useMockData";

export default function Contact() {
  const { heroData, finalCTA } = useContactData();
  return (
    <PageLayout>
      <InfoPageHero
        label="CONTACT"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="お問い合わせ"
      />
      <InquiryTypesSection />
      <ContactForm />
      <NotesSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
